import React from 'react';
import { Bell, Users, Clock, Layers, Building, Settings, ChevronLeft, ChevronRight, FileText, Archive, GitBranch } from 'lucide-react';
export const TabNavigation = ({
  activeDepartment,
  setActiveDepartment,
  activeView,
  setActiveView
}) => {
  const tabs = [{
    id: 'notifications',
    label: 'Notifications and Events',
    icon: <Bell className="h-5 w-5" data-id="element-1001" />,
    view: 'home'
  }, {
    id: 'employee',
    label: 'Employee Services',
    icon: <Users className="h-5 w-5" data-id="element-1002" />,
    view: 'home'
  }, {
    id: 'pending',
    label: 'Pending Requests',
    icon: <Clock className="h-5 w-5" data-id="element-1003" />,
    view: 'home'
  }, {
    id: 'documents',
    label: 'Documents',
    icon: <FileText className="h-5 w-5" data-id="element-1004" />,
    view: 'documents'
  }, {
    id: 'workflows',
    label: 'Workflows',
    icon: <GitBranch className="h-5 w-5" data-id="element-1005" />,
    view: 'workflows'
  }, {
    id: 'archive',
    label: 'Archive',
    icon: <Archive className="h-5 w-5" data-id="element-1006" />,
    view: 'archive'
  }, {
    id: 'platforms',
    label: 'Other Platforms',
    icon: <Layers className="h-5 w-5" data-id="element-1007" />,
    view: 'home'
  }, {
    id: 'gm-office',
    label: 'General Manager Office',
    icon: <Building className="h-5 w-5" data-id="element-1008" />,
    view: 'home'
  }];
  // Determine which tab is active based on the current view
  const getActiveTabId = () => {
    if (activeView === 'home') return 'notifications';
    return tabs.find(tab => tab.view === activeView)?.id || 'notifications';
  };
  return <div className="relative" data-id="element-1009">
      <div className="flex items-center justify-between border-b border-gray-200" data-id="element-1010">
        <div className="flex space-x-8 overflow-x-auto pb-2 scrollbar-hide" data-id="element-1011">
          {tabs.map(tab => <button key={tab.id} className={`flex items-center space-x-2 px-1 py-2 text-sm font-medium ${tab.id === getActiveTabId() ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => {
          setActiveView(tab.view);
          if (tab.id === 'gm-office') {
            setActiveDepartment('General Manager Office');
          }
        }} data-id="element-1012">
              {tab.icon}
              <span data-id="element-1013">{tab.label}</span>
            </button>)}
        </div>
        <div className="flex items-center space-x-2" data-id="element-1014">
          <button className="p-1 text-gray-400 hover:text-gray-600" data-id="element-1015">
            <ChevronLeft className="h-5 w-5" data-id="element-1016" />
          </button>
          <button className="p-1 text-gray-400 hover:text-gray-600" data-id="element-1017">
            <ChevronRight className="h-5 w-5" data-id="element-1018" />
          </button>
          <button className="p-1 text-gray-400 hover:text-gray-600" data-id="element-1019">
            <Settings className="h-5 w-5" data-id="element-1020" />
          </button>
        </div>
      </div>
    </div>;
};